import * as React from 'react';
import { createRoot, Root } from 'react-dom/client';
import BookmarkButton from './components/bookmark-button/BookmarkButton';
import { IBookmarkButtonProps } from './components/types';

const roots = new Map<HTMLElement, Root>();

if (window && window.shell) {
    window.shell.subscribeTo(
        'ESCID.ESPP.Bookmark.CreateClientSideAddBtn',
        (payload) => {
            const placeHolder: HTMLElement | null = document.getElementById(payload.containerId);

            if (placeHolder) {
                renderApp(payload, placeHolder);
            }
        },
        'ESCID.ESPP.Bookmark.CreateClientSideAddBtn'
    );
}

function renderApp(payload: IBookmarkButtonProps, placeHolder: HTMLElement) {
    let root = roots.get(placeHolder);

    if (!root) {
        root = createRoot(placeHolder);
        roots.set(placeHolder, root);
    }

    root.render(
        <div className="pdp-invisible_container bookmark-add-button">
            <BookmarkButton {...payload} />
        </div>
    );
}
